module.exports = __webpack_public_path__ + "static/media/avathar.577ad7ba.jpg";